var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "about" } },
    [
      _c("header", [
        _c(
          "a",
          { staticClass: "back", on: { click: _vm.closeAbout } },
          [
            _c("b-icon", {
              attrs: { size: "is-large", icon: "arrow-left", type: "" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("img", { staticClass: "logo", attrs: { src: _vm.logo } }),
      ]),
      _vm._v(" "),
      _c("about-md", { staticClass: "content" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }